const errorResponse = (response) => {
	return response;
};

const successResponse = (response) => {
	return response;
};

export { errorResponse, successResponse }